module.exports = __webpack_public_path__ + "static/media/html5+css3-900x900.e62f49f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/html5+css3-900x900.png
// module id = 65
// module chunks = 0